export default {
  metadata: {
    version: '1.0.0',
    id: 'footer-1.0.0',
    name: 'JDSFooter',
    platform: 'web'
  },
  hierarchy: {
    container: [
      {
        'main-container': [
          {
            'content-container': ['content-slot']
          },
          {
            'social-links-container': [
              'jds_footer_icon_links',
              'jds_footer_market_links'
            ]
          }
        ]
      },
      {
        'bottom-container': ['jds_divider', 'jds_bottom_footer']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{f_0}',
      'align-items': '{f_1}',
      size: '{f_2}',
      'background-color': '{f_3}'
    },
    'main-container': {
      'flex-direction': '{f_4}',
      'justify-content': '{f_5}',
      'align-items': '{f_6}',
      gap: '{f_7}',
      size: '{f_8}',
      'padding-top': '{f_9}',
      'padding-bottom': '{f_10}',
      'padding-left': '{f_11}',
      'padding-right': '{f_12}'
    },
    'social-links-container': {
      'padding-top': '{f_13}',
      'flex-direction': '{f_14}',
      gap: '{f_15}',
      width: '{f_28}'
    },
    'bottom-container': {
      'flex-direction': '{f_16}',
      'align-items': '{f_17}',
      width: '{f_18}',
      gap: 0
    },
    jds_divider: {
      pad: 'none'
    },
    jds_bottom_footer: {
      _platform: 'desktop'
    },
    'content-container': {
      width: '{f_19}'
    },
    'content-slot': {
      width: '{f_20}'
    }
  },
  variant: {
    _platform: {
      mobile: {
        'bottom-container': {
          gap: '{f_21}'
        },
        jds_bottom_footer: {
          _platform: 'mobile'
        },
        'main-container': {
          'flex-direction': '{f_22}',
          'justify-content': '{f_23}',
          'padding-top': '{f_24}',
          'padding-bottom': '{f_25}',
          'padding-left': '{f_26}',
          'padding-right': '{f_27}'
        }
      }
    },
    _hasMainContainerProps: {
      false: {
        'main-container': {
          hidden: true
        }
      }
    },
    _hasContentSlot: {
      false: {
        'content-container': {
          hidden: true
        }
      }
    },
    _hasSocialLinksContainer: {
      false: {
        'social-links-container': {
          hidden: true
        }
      }
    },
    _hasFooterIconLinks: {
      false: {
        jds_footer_icon_links: {
          hidden: true
        }
      }
    }
  },
  api: {
    config: {
      _platform: {
        values: ['desktop', 'mobile']
      },
      _hasMainContainerProps: {
        values: [true, false]
      },
      _hasContentSlot: {
        values: [true, false]
      },
      _hasSocialLinksContainer: {
        values: [true, false]
      },
      _hasFooterIconLinks: {
        values: [true, false]
      }
    },
    children: {
      'content-slot': {
        name: 'children',
        accepts: ['any']
      }
    },
    data: {
      main_container: {
        value: {
          name: 'links',
          type: 'object',
          object: {
            links: 'list'
          }
        }
      },
      'social-links-container': {
        marketplace: {
          type: 'object',
          name: 'marketplace',
          object: {
            assets: 'JDSFooterMarketLinks.assets',
            title: 'string'
          }
        },
        social: {
          type: 'object',
          name: 'social',
          object: {
            links: 'JDSFooterIconLinks.links',
            title: 'string'
          }
        }
      },
      jds_footer_icon_links: {
        links: {
          name: 'social.links',
          type: 'JDSFooterIconLinks.links'
        },
        title: {
          name: 'social.title',
          type: 'string'
        }
      },
      jds_footer_market_links: {
        assets: {
          name: 'marketplace.assets',
          type: 'JDSFooterMarketLinks.assets'
        },
        title: {
          name: 'marketplace.title',
          type: 'string'
        }
      },
      'bottom-container': {
        value: {
          name: 'copyright',
          type: 'object'
        }
      },
      jds_bottom_footer: {
        copyright: {
          type: 'JDSBottomFooter.copyright',
          name: 'copyright'
        },
        copyrightText: {
          type: 'string',
          name: 'copyrightText'
        },
        informationalLinks: {
          type: 'JDSBottomFooter.informationalLinks',
          name: 'bottomLinks'
        },
        logo: {
          type: 'icon',
          name: 'logo'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'navigation'
          },
          'aria-label': {
            name: 'ariaLabel',
            value: 'Footer'
          }
        }
      },
      jds_bottom_footer: {
        properties: {
          copyRightAriaLabel: 'copyRightAriaLabel',
          copyRightAriaDescribedby: {
            name: 'copyRightAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
